import "core-js/modules/es.symbol.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.array.for-each.js";
import "core-js/modules/es.object.define-properties.js";
import "core-js/modules/es.object.define-property.js";
import "core-js/modules/es.object.get-own-property-descriptor.js";
import "core-js/modules/es.object.get-own-property-descriptors.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/web.dom-collections.for-each.js";
import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _regeneratorRuntime from "@babel/runtime/regenerator";
import "core-js/modules/es.array.includes.js";
import "core-js/modules/es.date.to-json.js";
import "core-js/modules/es.date.to-string.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.promise.js";
import "core-js/modules/es.string.includes.js";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
// Vendors
import cookies from "../cookies/cookies";
import httpStatusUtils from "../http-status/http-status.utils";
// Constants
import apiClientConstants from "../../constants/api-client";
import constants from "./constants/api-client.constants";
import storageConstants from "../../constants/storage";
// Configurations
import { doRefreshTokenAction, getInitHeaders } from "./configurations/api.configurations";
// Utils
import { buildFetchUrl, parseResponseBody } from "./helpers/api.helpers";
import sessionUtils from "../session/session.utils";
// Types

var HTTP_STATUS_401_FOUND = false;
var getFetchRequestArguments = function getFetchRequestArguments(_ref) {
  var body = _ref.body,
    channel = _ref.channel,
    _ref$customHeaders = _ref.customHeaders,
    customHeaders = _ref$customHeaders === void 0 ? {} : _ref$customHeaders,
    hasCommonHeaders = _ref.hasCommonHeaders,
    language = _ref.language,
    method = _ref.method,
    _ref$params = _ref.params,
    params = _ref$params === void 0 ? {} : _ref$params,
    url = _ref.url;
  var headers = hasCommonHeaders ? getInitHeaders({
    channel: channel,
    customHeaders: customHeaders,
    language: language
  }) : _objectSpread({}, customHeaders);
  if (headers['Content-Type'] === 'multipart/form-data') {
    delete headers['Content-Type'];
  }
  if (url !== null && url !== void 0 && url.includes('refresh-token') && cookies.getCookie(storageConstants.COOKIES_IDS.AGENT_TOKEN)) {
    headers[storageConstants.COOKIES_IDS.ACCESS_TOKEN] = cookies.getCookie(storageConstants.COOKIES_IDS.AGENT_TOKEN);
  }
  var init = _objectSpread(_objectSpread({}, constants.INIT_FETCH_CONFIG), {}, {
    method: method,
    headers: headers
  });
  if (method !== constants.METHODS.GET) init.body = JSON.stringify(params);
  if (body) init.body = body;
  return init;
};
var cleanSessionAndRedirect = function cleanSessionAndRedirect() {
  sessionUtils.clearSessionData();
  // if (window.location.pathname !== '/' && window.location.pathname !== '/login') {
  //   window.location.replace('/');
  // } else {
  //   return constants.DEFAULT_ERROR_RESPONSE;
  // }
  return constants.DEFAULT_REFRESH_ERROR_RESPONSE;
};
var refreshTokenService = /*#__PURE__*/function () {
  var _ref3 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee(_ref2) {
    var channel, response;
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          channel = _ref2.channel;
          _context.next = 3;
          return doRefreshTokenAction(channel)();
        case 3:
          response = _context.sent;
          response && localStorage.setItem('tokenRefreshed', 'true');
          return _context.abrupt("return", response || constants.DEFAULT_REFRESH_ERROR_RESPONSE);
        case 6:
        case "end":
          return _context.stop();
      }
    }, _callee);
  }));
  return function refreshTokenService(_x) {
    return _ref3.apply(this, arguments);
  };
}();
var buildCallService = function buildCallService(method) {
  return /*#__PURE__*/function () {
    var _ref4 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee2(props) {
      var absoluteUrl, body, _props$channel, channel, customHeaders, endpoint, _props$hasCommonHeade, hasCommonHeaders, language, params, pathParams, queryParams, url, fetchBody, fetchRequest, request, response, refreshResponse, refreshUrl, refreshFetchBody, fetchRefreshRequest, refreshRequest, _refreshResponse;
      return _regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) switch (_context2.prev = _context2.next) {
          case 0:
            absoluteUrl = props.absoluteUrl, body = props.body, _props$channel = props.channel, channel = _props$channel === void 0 ? apiClientConstants.CHANNELS.WEB : _props$channel, customHeaders = props.customHeaders, endpoint = props.endpoint, _props$hasCommonHeade = props.hasCommonHeaders, hasCommonHeaders = _props$hasCommonHeade === void 0 ? true : _props$hasCommonHeade, language = props.language, params = props.params, pathParams = props.pathParams, queryParams = props.queryParams;
            url = buildFetchUrl({
              absoluteUrl: absoluteUrl,
              endpoint: endpoint,
              pathParams: pathParams,
              queryParams: queryParams
            }), fetchBody = getFetchRequestArguments({
              body: body,
              channel: channel,
              customHeaders: customHeaders,
              hasCommonHeaders: hasCommonHeaders,
              language: language,
              method: method,
              params: params,
              url: url
            }), fetchRequest = function fetchRequest() {
              return fetch(url, fetchBody);
            };
            _context2.prev = 2;
            _context2.next = 5;
            return fetchRequest();
          case 5:
            request = _context2.sent;
            _context2.next = 8;
            return parseResponseBody(request);
          case 8:
            response = _context2.sent;
            if (!(
            // Is candidate to refresh
            httpStatusUtils.isUnauthorizedStatus(request === null || request === void 0 ? void 0 : request.status) && !HTTP_STATUS_401_FOUND && cookies.getCookie(storageConstants.COOKIES_IDS.ACCESS_TOKEN) && localStorage.getItem(storageConstants.LOCALSTORAGE_IDS.USERNAME) && cookies.getCookie(storageConstants.COOKIES_IDS.REFRESH_TOKEN))) {
              _context2.next = 29;
              break;
            }
            HTTP_STATUS_401_FOUND = true;
            _context2.next = 13;
            return refreshTokenService({
              channel: channel,
              method: method,
              props: props,
              request: request
            });
          case 13:
            refreshResponse = _context2.sent;
            if (!refreshResponse) {
              _context2.next = 26;
              break;
            }
            refreshUrl = buildFetchUrl({
              absoluteUrl: absoluteUrl,
              endpoint: endpoint,
              pathParams: pathParams,
              queryParams: queryParams
            }), refreshFetchBody = getFetchRequestArguments({
              body: body,
              channel: channel,
              customHeaders: customHeaders,
              hasCommonHeaders: hasCommonHeaders,
              language: language,
              method: method,
              params: params,
              url: url
            }), fetchRefreshRequest = function fetchRefreshRequest() {
              return fetch(refreshUrl, refreshFetchBody);
            };
            _context2.next = 18;
            return fetchRefreshRequest();
          case 18:
            refreshRequest = _context2.sent;
            _context2.next = 21;
            return parseResponseBody(refreshRequest);
          case 21:
            _refreshResponse = _context2.sent;
            HTTP_STATUS_401_FOUND = false;
            return _context2.abrupt("return", [_refreshResponse, refreshRequest]);
          case 26:
            cleanSessionAndRedirect();
          case 27:
            _context2.next = 32;
            break;
          case 29:
            localStorage.setItem('lastApiCall', String(new Date()));
            // Return everything excepting 401 with accesstoken and refresh token
            HTTP_STATUS_401_FOUND = false;
            return _context2.abrupt("return", [response, request]);
          case 32:
            _context2.next = 38;
            break;
          case 34:
            _context2.prev = 34;
            _context2.t0 = _context2["catch"](2);
            HTTP_STATUS_401_FOUND = false;
            //cleanSessionAndRedirect();
            return _context2.abrupt("return", constants.DEFAULT_ERROR_RESPONSE);
          case 38:
          case "end":
            return _context2.stop();
        }
      }, _callee2, null, [[2, 34]]);
    }));
    return function (_x2) {
      return _ref4.apply(this, arguments);
    };
  }();
};
var methods = {
  get: buildCallService(constants.METHODS.GET),
  patch: buildCallService(constants.METHODS.PATCH),
  post: buildCallService(constants.METHODS.POST),
  put: buildCallService(constants.METHODS.PUT),
  "delete": buildCallService(constants.METHODS.DELETE)
};
export default methods;